import React from 'react'

import {FieldViewSize} from "../../../../../const"

export default function FieldSelectView_FormValueEmpty(props:any) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)
    const placeholder = props.field.noValueOption ? props.field.noValueOptionLabel : props.field.placeholder

    const classes = Classes("ui5-field-form-editable light-border gray-bg dropdown-form", props.className, {
        'h-36'                      : size === FieldViewSize.DEFAULT,
        'h-28'                      : size === FieldViewSize.SMALL,
        'ui5-txt-no-accent-default' : !props.field.noValueOption,
        'ui5-txt-default'           : !!props.field.noValueOption,
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {!!props.field.noValueOptionIcon &&
                    <div className={Classes("ui5-ico-15 m-r-8", props.field.noValueOptionIcon)}/>}
                {placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )
}
